export enum ForOptTarif {
  AnnualPremium = "AnnualPremium",
  QuarterPremium = "QuarterPremium",
  MonthlyPremium = "MonthlyPremium",
  OBJVAL = "OBJVAL",
  PackageId = "PackageId",
  CAP_MOB = "CAP_MOB",
  RCS = "RCS",
  PJ = "PJ",
  VAN= "VAN",
  NumberOfChildren = "NumberOfChildren",
  NOM_ENFANT = "NOM_ENFANT",
  PRENOM_ENFANT = "PRENOM_ENFANT",
  DATE_ENFANT = "DATE_ENFANT",
}
